/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetDashboardItemsResponse } from './AssetDashboardItemsResponse';
import {
    AssetDashboardItemsResponseFromJSON,
    AssetDashboardItemsResponseFromJSONTyped,
    AssetDashboardItemsResponseToJSON,
    AssetDashboardItemsResponseToJSONTyped,
} from './AssetDashboardItemsResponse';

/**
 * 
 * @export
 * @interface AssetDashboardResponse
 */
export interface AssetDashboardResponse {
    /**
     * 
     * @type {Date}
     * @memberof AssetDashboardResponse
     */
    serverTimeUtc?: Date;
    /**
     * 
     * @type {AssetDashboardItemsResponse}
     * @memberof AssetDashboardResponse
     */
    syncItems?: AssetDashboardItemsResponse;
}

/**
 * Check if a given object implements the AssetDashboardResponse interface.
 */
export function instanceOfAssetDashboardResponse(value: object): value is AssetDashboardResponse {
    return true;
}

export function AssetDashboardResponseFromJSON(json: any): AssetDashboardResponse {
    return AssetDashboardResponseFromJSONTyped(json, false);
}

export function AssetDashboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDashboardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'serverTimeUtc': json['serverTimeUtc'] == null ? undefined : (new Date(json['serverTimeUtc'])),
        'syncItems': json['syncItems'] == null ? undefined : AssetDashboardItemsResponseFromJSON(json['syncItems']),
    };
}

export function AssetDashboardResponseToJSON(json: any): AssetDashboardResponse {
    return AssetDashboardResponseToJSONTyped(json, false);
}

export function AssetDashboardResponseToJSONTyped(value?: AssetDashboardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serverTimeUtc': value['serverTimeUtc'] == null ? undefined : ((value['serverTimeUtc']).toISOString()),
        'syncItems': AssetDashboardItemsResponseToJSON(value['syncItems']),
    };
}

